import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { WindowRef } from '@spartacus/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[autofocus]',
  standalone: true,
})
export class AutofocusDirective implements AfterViewInit {
  constructor(
    private elementRef: ElementRef,
    private winRef: WindowRef,
  ) {}

  ngAfterViewInit(): void {
    if (this.winRef.isBrowser()) {
      this.elementRef.nativeElement.focus();
    }
  }
}
